import i18n from 'i18next';

const keys = [
    "p1_1", "p1_2", "p1_3", "p1_4", "p1_5", "p1_6", "p1_7", "p1_8",
    "p2_1", "p2_2", "p2_3", "p2_4", "p2_5", "p2_6", "p2_7", "p2_8", "p2_9", "p2_10",
    "p3_1", "p3_2", "p3_3", "p3_4",
    "p4_1", "p4_2", "p4_3", "p4_4", "p4_5", "p4_6", "p4_7", "p4_8", "p4_9", "p4_10", "p4_11", "p4_12", "p4_13", "p4_14", "p4_15",
    "p5_2", "p5_3",
    "p6_2", "p6_3",
    "p7_0", "p7_1", "p7_2", "p7_3", "p7_4", "p7_5",
    "p8_0", "p8_1", "p8_2",
    "p9_0", "p9_1", "p9_2"
];

/**
 * Devuelve las incidencias traducidas al idioma actual
 * Usa las traducciones de pdfs.json > incidencias
 */
export const getIncidencias = () => {
    const result = {};
    keys.forEach(key => {
        result[key] = i18n.t(`pdfs:incidencias.${key}`);
    });
    return result;
};

// Mantener compatibilidad: exportar como proxy que traduce en tiempo real
export const incidencias = new Proxy({}, {
    get(_, key) {
        if (typeof key === 'string' && keys.includes(key)) {
            return i18n.t(`pdfs:incidencias.${key}`);
        }
        return undefined;
    }
});
